import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom'

import { UserContext } from '../../contexts/user'

export default function Pannel() {
  const { data } = useContext(UserContext)

  return (
    <div className="column is-2-desktop is-hidden-touch">
      <aside className="menu">
        {data.user.profile.menuDetails.map(({ id, type, children, url }) => {
          return (
            <React.Fragment key={id}>
              <p
                className="menu-label"
                style={{ fontSize: '17px', fontWeight: 'bold' }}
              >
                {type === 'Seguridad' ? (
                  <i
                    className="fas fa-shield-alt"
                    style={{ fontSize: '22px', color: '#1844B6' }}
                  ></i>
                ) : <div></div> && type === 'Catalogo' ? (
                  <i
                    className="fas fa-th-large"
                    style={{ fontSize: '22px', color: '#1844B6' }}
                  ></i>
                ) : <div></div> && type === 'Reportes' ? (
                  <i
                    className="fas fa-scroll"
                    style={{ fontSize: '22px', color: '#1844B6' }}
                  ></i>
                ) : <div></div> && type === 'Dashboard' ? (
                  <i
                    className="fas fa-tachometer-alt"
                    style={{ fontSize: '22px', color: '#1844B6' }}
                  ></i>
                ) : (
                  <div></div>
                )}{' '}
                {type}
              </p>

              <ul className="menu-list">
                {children.map(element => {
                  return (
                    <li key={element.type}>
                      <NavLink
                        to={url + element.url}
                        activeClassName="is-active"
                        isActive={(match, location) => {
                          return location.pathname.includes(
                            !!match && match.url,
                          )
                        }}
                        className="ml-5"
                      >
                        {element.type}
                      </NavLink>
                    </li>
                  )
                })}
              </ul>
            </React.Fragment>
          )
        })}
      </aside>
    </div>
  )
}
